// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
/**
 * (ds)
 * wird von ionic 3 nicht ber�cksichtigt
 */
export const environment = {
  production: true,
  version: '(prod)',
  serverUrl: '', // wir hosten die checklists in der Production-Version direkt unterhalb von /, also /checklists
  defaultLanguage: 'de-DE',
  supportedLanguages: [
    'de-DE'
  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts